import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { patchOnboardingState } from "@services/api";
import { mergeOnboardingEntries } from "./onboardingSlice";
import type { OnboardingEntryJSON } from "@/types/models";

/**
 * Persist one entry of the onboarding map.
 *
 * Writes go to the store (and through it, IndexedDB for demo and
 * anonymous visitors); signed-in users also patch the server, whose
 * key-level merge means concurrent flows — the tour and any hint —
 * can't clobber each other.
 */
export function useOnboardingSave() {
  const dispatch = useAppDispatch();
  const userId = useAppSelector((s) => s.user.userId);

  return useCallback(
    (key: string, entry: OnboardingEntryJSON) => {
      dispatch(mergeOnboardingEntries({ [key]: entry }));
      if (userId) {
        patchOnboardingState({ [key]: entry });
      }
    },
    [dispatch, userId]
  );
}
